import { render } from "./FileUploadTemplate.vue?vue&type=template&id=f85bc882"
import script from "./FileUploadTemplate.vue?vue&type=script&lang=js"
export * from "./FileUploadTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script